import { Routes } from '@angular/router';
import { preQualifyBrandingResolver } from './pre-qualify-branding.resolver';
import { preQualifyGuard } from './pre-qualify.resolver';

export const preQualifyRoutes: Routes = [
  {
    path: 'welcome',
    loadComponent: () =>
      import('./welcome/welcome.component').then((m) => m.WelcomeComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./pre-qualify.component').then((m) => m.PreQualifyComponent),
    canActivate: [preQualifyGuard],
    resolve: { branding: preQualifyBrandingResolver },
    children: [
      { path: '', redirectTo: 'title', pathMatch: 'full' },
      {
        path: 'title',
        loadComponent: () =>
          import('./steps/title/title.component').then((m) => m.PqTitleComponent),
      },
      {
        path: 'first-name',
        loadComponent: () =>
          import('./steps/first-name/first-name.component').then(
            (m) => m.PqFirstNameComponent
          ),
      },
      {
        path: 'last-name',
        loadComponent: () =>
          import('./steps/last-name/last-name.component').then(
            (m) => m.PqLastNameComponent
          ),
      },
      {
        path: 'email',
        loadComponent: () =>
          import('./steps/email/email.component').then(
            (m) => m.PqEmailComponent
          ),
      },
      {
        path: 'help-type',
        loadComponent: () =>
          import('./steps/help-type/help-type.component').then(
            (m) => m.PqHelpTypeComponent
          ),
      },
      {
        path: 'new-home/applicant-type',
        loadComponent: () =>
          import('./steps/new-home/applicant-type/applicant-type.component').then(
            (m) => m.NhApplicantTypeComponent
          ),
      },
      {
        path: 'new-home/property-found',
        loadComponent: () =>
          import('./steps/new-home/property-found/property-found.component').then(
            (m) => m.NhPropertyFoundComponent
          ),
      },
      {
        path: 'new-home/purchase-price',
        loadComponent: () =>
          import('./steps/new-home/purchase-price/purchase-price.component').then(
            (m) => m.NhPurchasePriceComponent
          ),
      },
      {
        path: 'new-home/deposit',
        loadComponent: () =>
          import('./steps/new-home/deposit/deposit.component').then(
            (m) => m.NhDepositComponent
          ),
      },
      {
        path: 'new-home/annual-income',
        loadComponent: () =>
          import('./steps/new-home/annual-income/annual-income.component').then(
            (m) => m.NhAnnualIncomeComponent
          ),
      },
      {
        path: 'new-home/mobile-number',
        data: { stepId: 'nh-mobile-number', sectionLabel: 'New home', sectionIcon: 'house', applicant: 'applicant1', testId: 'nh-mobile-number' },
        loadComponent: () =>
          import('./steps/shared/mobile-number/mobile-number.component').then(
            (m) => m.PqMobileNumberComponent
          ),
      },
      {
        path: 'remortgage/applicant-type',
        loadComponent: () =>
          import('./steps/remortgage/applicant-type/applicant-type.component').then(
            (m) => m.RmApplicantTypeComponent
          ),
      },
      {
        path: 'remortgage/property-value',
        loadComponent: () =>
          import('./steps/remortgage/property-value/property-value.component').then(
            (m) => m.RmPropertyValueComponent
          ),
      },
      {
        path: 'remortgage/outstanding-mortgage',
        loadComponent: () =>
          import(
            './steps/remortgage/outstanding-mortgage/outstanding-mortgage.component'
          ).then((m) => m.RmOutstandingMortgageComponent),
      },
      {
        path: 'remortgage/raise-funds',
        loadComponent: () =>
          import('./steps/remortgage/raise-funds/raise-funds.component').then(
            (m) => m.RmRaiseFundsComponent
          ),
      },
      {
        path: 'remortgage/raise-funds-amount',
        loadComponent: () =>
          import(
            './steps/remortgage/raise-funds-amount/raise-funds-amount.component'
          ).then((m) => m.RmRaiseFundsAmountComponent),
      },
      {
        path: 'remortgage/annual-income',
        loadComponent: () =>
          import('./steps/remortgage/annual-income/annual-income.component').then(
            (m) => m.RmAnnualIncomeComponent
          ),
      },
      {
        path: 'remortgage/mobile-number',
        data: { stepId: 'rm-mobile-number', sectionLabel: 'Remortgage', sectionIcon: 'remortgage', applicant: 'applicant1', testId: 'rm-mobile-number' },
        loadComponent: () =>
          import('./steps/shared/mobile-number/mobile-number.component').then(
            (m) => m.PqMobileNumberComponent
          ),
      },
      {
        path: 'joint/title',
        loadComponent: () =>
          import('./steps/joint/title/title.component').then(
            (m) => m.JointTitleComponent
          ),
      },
      {
        path: 'joint/first-name',
        loadComponent: () =>
          import('./steps/joint/first-name/first-name.component').then(
            (m) => m.JointFirstNameComponent
          ),
      },
      {
        path: 'joint/last-name',
        loadComponent: () =>
          import('./steps/joint/last-name/last-name.component').then(
            (m) => m.JointLastNameComponent
          ),
      },
      {
        path: 'joint/email',
        loadComponent: () =>
          import('./steps/joint/email/email.component').then(
            (m) => m.JointEmailComponent
          ),
      },
      {
        path: 'joint/annual-income',
        loadComponent: () =>
          import('./steps/joint/annual-income/annual-income.component').then(
            (m) => m.JointAnnualIncomeComponent
          ),
      },
      {
        path: 'joint/mobile-number',
        data: { stepId: 'joint-mobile-number', sectionLabel: 'Joint applicant', sectionIcon: 'joint', applicant: 'applicant2', testId: 'joint-mobile-number' },
        loadComponent: () =>
          import('./steps/shared/mobile-number/mobile-number.component').then(
            (m) => m.PqMobileNumberComponent
          ),
      },
      {
        path: 'review',
        loadComponent: () =>
          import('./steps/review-submit/review-submit.component').then(
            (m) => m.ReviewSubmitComponent
          ),
      },
      {
        path: 'success',
        loadComponent: () =>
          import('./steps/success/success.component').then(
            (m) => m.PreQualifySuccessComponent
          ),
      },
    ],
  },
];
